import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { 
  interpretMetadata, 
  contentfulMetadataPropType 
} from '@glowforge/gf-styled/src/models/page-metadata';
import PageMetadata from '@glowforge/gf-styled/src/components/contentful-views/page-metadata';
import { pagePropType } from '../../prop-types/contentful';

/**
 * The `Page` component in ui-common does not include page metadata for pages
 * with type `custom`. Usually we want custom pages to have their own metadata
 * that inherits from the default page metadata. In order to do this, we can
 * explicitly include the `PageMetadata` component in custom pages we create.
 */
const CustomPageMetadata = ({ page, metadata, stringSubstitutions }) => {
  let meta;

  if (page) {
    meta = get(page, 'fields.pageMetadata', {});
  } else {
    meta = metadata;
  }

  if (!meta) {
    return null;
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <PageMetadata {...interpretMetadata(meta, stringSubstitutions)} />
  );
};

CustomPageMetadata.propTypes = {
  page: pagePropType,
  metadata: PropTypes.shape(contentfulMetadataPropType),
  stringSubstitutions: PropTypes.objectOf(PropTypes.string),
};

CustomPageMetadata.defaultProps = {
  page: null,
  metadata: null,
  stringSubstitutions: {},
};

export default CustomPageMetadata;
